//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//style
import './Gifts.scss';

//api
import { api } from '../../functions/api';

//custom components
import CustomTable from '../../components/complex/customTable';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';

// import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddEditItem from './AddEditItem/AddEditItem';
import DeleteDialog from '../../components/global/deleteDialog';

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import { debounce } from 'lodash'

@inject('internal')
@inject('translate')
@observer
export default class Gifts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            addEditDialog: false,
            shop_id: 2
        }
    }

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            action: "edit"
        },
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
        },
    ]

    tableHeader = [
        {
            "title": "name",
            "numeric": false,
            "min_width": "150px",

        },
        {
            "title": "description",
            "numeric": false,
            "min_width": "150px",

        },
        {
            "title": "price_from",
            "numeric": true,
            "min_width": "100px"
        },
        {
            "title": "production",
            "numeric": false,
            "textAlign": "center"
        },
    ];
    tableBody = [
        "name",
        "description",
        "price_from",
        "production",
    ]

    componentDidMount() {
        const { user } = toJS(this.props.internal)

        this.setState({shop_id: Number(this.props.match.params.idShop)})

        if(user && user.data && user.data.permissions && user.data.permissions.lists_gifts && user.data.permissions.lists_gifts.view) {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.GIFTS);
            // this.setPermissions()
            this.loadGifts()

        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }

    }

    componentWillReceiveProps() {
        if(Number(this.props.match.params.idShop) !== this.state.shop_id) {
            this.setState({shop_id: Number(this.props.match.params.idShop), loadingPage: true})
            this.loadGifts()
        }
    }

    loadGifts = async(size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {

            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let shop_id = "";
        let filters = {};
        let params = {
            searchterm: searchterm,
            page:{
                number: page,
                size: size,
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        };

        // shop_id = 2;
        shop_id = Number(this.props.match.params.idShop)
        filters.shop_id = shop_id
        params.filters = filters

        let load_data = await api({
            method:'get',
            url: 'products/gifts',
            // postman: true,
            authorization: this.props.internal.user.access_token,
            params: params
        })
        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
            }
        }
        this.setState({loadingPage: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = debounce((searchTerm) => {
        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else  {
            this.addQueryToUrl("searchterm", "")
        }
    }, 500)

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadGifts()
    }

    changeProductionStatus = async(id, status) => {

        let update_data = await api({
            url: `products/gifts/${id}`,
            method: 'patch',
            authorization: this.props.internal.user.access_token,
            // postman: true,
            params: {
                production: status
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.loadGifts()
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleDelete = async () => {
        let idGift = toJS(this.props.internal.actionDeleteObj.id)
        let delete_menut_item = await api({
            method: 'delete',
            url: `products/gifts/${idGift}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_menut_item.success === true) {
            this.props.internal.setSnackbar(delete_menut_item.data.message, true)
            this.loadGifts();
            this.props.internal.setActionDelete();
        }
    }

    handleOpenCloseDialog = async(refresh = false) => {

        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(refresh) {
            this.loadGifts()
        }
    }

    render () {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :

                <div className={'giftsModule'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.GIFTS.DELETE_GIFT_ITEM_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEditItem
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES.GIFTS.DIALOG_TITLE_CREATE : this.props.translate.i18n.MODULES.GIFTS.DIALOG_TITLE_EDIT}
                            typeMenu={this.state.typeMenu}
                            setMenuPosition={this.setMenuPosition}
                            shop_id={this.state.shop_id}
                        />
                    }

                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {user && user.data && user.data.permissions && user.data.permissions.lists_gifts && user.data.permissions.lists_gifts.store ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES.GIFTS.CREATE_NEW_GIFT_ITEM}
                                onClick = {this.handleOpenCloseDialog}
                            >
                                <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        }
                    </div>

                    <CustomTable
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/gifts'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                        // openDialogSiblings={this.openCloseDialogChangePosition}
                        // updateTypeMenuItem={this.updateTypeMenuItem}
                        clickOnProductionStatus={this.changeProductionStatus}
                        // disablePagination
                        // disableSort
                    />
                </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/gifts/Gifts.jsx